// 注册element组件
import "./use"

import modal from "./modal"
import cache from "./cache"
import newMessage from "./reset-message"
export default {
  install(Vue) {
    // 模态框对象
    Vue.prototype.$modal = modal
    // 缓存对象
    Vue.prototype.$cache = cache
    // 消息提示
    Vue.prototype.$message = newMessage
  }
}
